import DataService from '../data.service';
class GenericAPI {
    many(resource, ids) {
        return DataService.get(resource, { ids, nopagination: true });
    }
    all(resource, filter = {}) {
        return DataService.get(resource, { filter, pagination: { page: 1, pageSize: 1000 } });
    }
    search(resource, q, pagination = { page: 1, pageSize: 6 }) {
        return DataService.get(resource, { filter: { q: { val: q } }, pagination });
    }
    create(resource, body) {
        return DataService.post(resource, body);
    }
    update(resource, body) {
        return DataService.put(resource, body);
    }
    get(resource, id) {
        return DataService.get(resource + "/" + String(id));
    }
    delete(resource, id) {
        return DataService.delete(resource + "/" + String(id));
    }
}

export default new GenericAPI();